import React, { useState } from 'react';
import {
    Box, Typography, IconButton, CardContent, Link, CardHeader, Tooltip, Menu, MenuItem,
} from '@mui/material';
//import ArticleCardActions from './ArticleCardActions';
//import ArticleCardTags from './ArticleCardTags';
//import DeleteIcon from '@mui/icons-material/Delete';
//import { ConstructionOutlined, ExpandLess as ExpandLessIcon, ExpandMore as ExpandMoreIcon } from '@mui/icons-material';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { formatDistanceToNow, format } from 'date-fns';
import CircleIcon from '@mui/icons-material/Circle';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import he from 'he';
//import { updateCurrentUser } from 'firebase/auth';
import { useAuth } from '../contexts/AuthContext';



const ArticleCardContent = React.memo(({ article, handleSelectArticle, handleDelete, handleExpandClick, expandedArticleId, selectedArticles }) => {
    // State for the menu anchor element
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
    const skepticSources = ['breitbart.com', 'dailycaller.com', 'foxnews.com', 'nypost.com', 'thefederalist.com', 'zerohedge.com', 'wattsupwiththat.com', 'climatechangedispatch.com', 'judicialwatch.org', 'thegatewaypundit'];
    const isSelected = selectedArticles.includes(article);
    //const logoURL = article.feedURL ? `https://logo.clearbit.com/${new URL(article.feedURL).hostname}` : '';
    const { currentUser } = useAuth();
    //To convert the pubDate to a relative time format like "x hours ago" or "2 days ago" and 
    //show the exact date when it is more than a certain number of days ago, you can use a library like date-fns. 
    //The date-fns library provides a function called formatDistanceToNow that can be used to achieve this.
    const pubDate = new Date(article.pubDate);
    const now = new Date();
    const daysDifference = Math.floor((now - pubDate) / (1000 * 60 * 60 * 24));
    const relativeTime = daysDifference > 7 ? format(pubDate, 'yyyy-MM-dd') : formatDistanceToNow(pubDate, { addSuffix: true });

    // Define the placeholder image URL or path
    const placeholderImage = 'https://placehold.co/80'; // Replace with the actual URL or path

    // Determine link text based on the availability of article.article.source
    const source = article.article?.source;
    const tags = article.tags?.join(', ') || '';

    // Construct the subheader text based on source and tags
    let subheaderText = '';
    if (source && tags) {
        subheaderText += ` by ${source}, tags: ${tags}`;
    } else if (source) {
        subheaderText += ` by ${source}`;
    } else if (tags) {
        subheaderText += `, tags: ${tags}`;
    }

    // Calculate the number of dots based on score
    const scoreValue = parseFloat(article.score) || 0;
    const numberOfDots = Math.ceil(scoreValue / 20);
    const dots = Math.max(1, Math.min(5, numberOfDots));

    // Determine the color based on the number of dots
    let dotColor = 'red';
    if (dots === 1) {
        dotColor = 'red';
    } else if (dots === 2) {
        dotColor = 'orange';
    } else if (dots === 3) {
        dotColor = 'yellow';
    } else if (dots >= 4) {
        dotColor = 'green';
    }

    // Generate dot icons
    const dotIcons = [];
    for (let i = 0; i < dots; i++) {
        dotIcons.push(
            <CircleIcon key={i} style={{ color: dotColor, fontSize: 'small' }} />
        );
    }
    // Handler to open the menu
    const handleMenuOpen = (event) => {
        setAnchorEl(event.currentTarget);
    };

    // Handler to close the menu
    const handleMenuClose = () => {
        setAnchorEl(null);
    };

    // Handler for the delete action
    const handleDeleteClick = () => {
        handleDelete(article.id);
        setAnchorEl(null);
    };

    return (
        <>
            <CardHeader
                action={
                    <IconButton
                        aria-label="settings"
                        aria-controls={open ? 'article-menu' : undefined}
                        aria-haspopup="true"
                        onClick={handleMenuOpen}
                    >
                        <MoreVertIcon color="lightgrey" />
                    </IconButton>
                }
                title={
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        <Typography
                            variant="subtitle1"
                            sx={{ color: '#FFA500', fontWeight: 'bold' }}
                        >
                            <Link
                                href={article.link}
                                title={article.link.split('?')[0]}
                                target="_blank"
                                rel="noopener"
                                underline="hover"
                                sx={{
                                    color: '#FFA500',
                                    fontWeight: 'bold',
                                    //marginTop: 2, 
                                    display: 'inline-block'
                                }}
                            >
                                {article.article ? he.decode(article.article?.title) : he.decode(article.title)}
                            </Link>

                        </Typography>
                        {skepticSources.includes(article.article?.source) && (
                            <Tooltip title="Disclaimer: The views and claims presented in this article may not align with the consensus of mainstream climate science. We encourage readers to critically evaluate the information in this article.">
                                <ErrorOutlineIcon
                                    color="error"
                                    fontSize="small"
                                    sx={{ ml: 0.5 }}
                                /></Tooltip>
                        )}
                    </Box>
                }
                subheader={
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        <Typography variant="caption" sx={{ color: '#B0B0B0' }}>
                            <Tooltip title={format(pubDate, 'dd-MM-yyyy HH:mm')}><span>{relativeTime}</span></Tooltip>
                            {subheaderText && (
                                <>
                                    {' '}
                                    {subheaderText}
                                </>
                            )}
                        </Typography>
                        {/* Add margin-left to space the icons from the text */}
                        {dotIcons.length > 0 && (
                            <Tooltip title={`Score: ${article.score}: ${article.comment || ''}`}>
                                <Box sx={{ display: 'flex', ml: 1 }}>
                                    {dotIcons}
                                </Box>
                            </Tooltip>
                        )}
                    </Box>
                }
                sx={{ paddingBottom: 0 }}
            />{currentUser?.isAdmin && (
            <Menu
                id="article-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleMenuClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                }}
                transformOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                }}
            > <MenuItem onClick={() => handleDeleteClick()}>Delete article</MenuItem>
                
               
            </Menu>)}
            <CardContent>
                <Box sx={{ overflow: 'hidden', color:isSelected?'blue':'red'}} onClick={() => handleSelectArticle(article)}>
                    <Typography
                        variant="body2"
                        sx={{ color: '#D0D0D0' }}
                    >
                        <img
                            src={
                                article.article?.image || article.image || placeholderImage
                            }
                            alt={article.title}
                            style={{
                                height: '80px',
                                marginRight: '16px',
                                float: 'left',
                                marginBottom: '8px',
                            }}
                            onError={(e) => {
                                console.error(
                                    `Failed to load image for ${article.title}`,
                                    e
                                );
                                e.target.onerror = null; // Prevent infinite loop if placeholder fails
                                e.target.src = placeholderImage; // Set the placeholder image
                            }}
                        />
                        {article.TLDR || article.description || "no description available"}
                    </Typography>            
                </Box>
            </CardContent>

        </>

    );
});

export default ArticleCardContent;